// Este arquivo define o contexto de autenticação para ser usado no React. Ele fornece a estrutura para armazenar e manipular os dados do usuário autenticado.
// Este contexto será utilizado pelo JwtAuthProvider para fornecer os dados de autenticação globalmente.

import { createContext } from 'react';
import { User } from '../../user';

export type JwtAuthContextType = {
	user: User | null; // Informações do usuário autenticado.
	signIn: (email: string, password: string) => Promise<void>; // Método para fazer login.
	signUp: (email: string, password: string, firstName: string, lastName: string) => Promise<void>;
	signOut: () => void; // Método para logout.
	refreshToken: () => Promise<void>; // Método para renovar o token.
};

// Cria o JwtAuthContext usando createContext.
const JwtAuthContext = createContext<JwtAuthContextType | null>(null);

export default JwtAuthContext;
